import { ENDPOINT } from 'api/endPoints/getLongestAddedActivities';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    ITableWidgetWrapperProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';

export const largestAddedActivities: IHashmapItemWithCustomProps<ITableWidgetWrapperProps> = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
    ],
    elementId: 'largest-added-activities',
    componentKey: 'largestAddedActivities',
    title: 'Largest Added Activities',
    id: 'longestAddedActivities',
    reportStyle: {
        widgetSizesAvailable: { medium: MEDIUM, large: LARGE, extraLarge: EXTRA_LARGE },
        widgetInitialSize: LARGE,
    },
    endpoint: ENDPOINT,
};
